(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/table-of-score-parts/event-row-header.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/table-of-score-parts/event-row-header.js');
"use strict";


const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const EventRowHeader = _ref => {
  let {
    eventItem,
    branding
  } = _ref;
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const {
    captionShort,
    captionLong
  } = eventItem;
  return React.createElement("span", {
    className: "u-flex u-flex-align-items-center u-flex-justify-content-center qp_score__event-header qp_score__event-header--".concat(branding)
  }, "".concat(isMobile ? captionShort : captionLong));
};
setGlobal('svs.components.sport.quickplayModal.tableOfScoreParts.EventRowHeader', EventRowHeader);

 })(window);